
<script>
	import listBase from '@_system/components/base/list.vue'
	export default {
		extends: listBase,
		name: 'systemtoolIndex',
		props: {

		},
		data() {
			return {
				componenttype:'system',
				moduleName: 'systemtool',
				windowName: '工具管理',
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			add() {
				import('@_system/components/forms/systemtool/form.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: 'systemtool',
						id: 0,
						controlltype: 1,
						show: true,
						foreingKey: {},
						extra: {}
					}
				})
			},
			edit(row) {
				import('@_system/components/forms/systemtool/form.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: 'systemtool',
						id: row.id,
						controlltype: 2,
						show: true,
						foreingKey: {},
						extra: {}
					}
				})
			},
			auth(row) {
				import('@_system/components/forms/auth/form.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: 'auth',
						id: row.id,
						show: true,
						extra: {
							type: 'systemtool',
						}
					}
				})
			},
			
		},
		components: {


		}
	}
</script>
